export default __webpack_public_path__ + "8b09cfd5ea948e093c2565f5f55f9517.jpg";